import {setupBasicSuggestSelect} from '../../../../common/suggests';

document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('client-biller-setting') != null) {
        // 銀行名の取得
        setupBasicSuggestSelect('#js-bank-name', '/client/findBank', '銀行名を入力', null, null, null);
		$('#js-bank-name').on('change', function(e) {
            let selectedBank = $('#js-bank-name option:selected').val();
            if (isNaN(selectedBank)) {
                selectedBank = '';
            }
            document.getElementById('js-bank-code').textContent = selectedBank;
            document.getElementById('js-branch-name').value = null;
            document.getElementById('js-branch-name').dispatchEvent(new Event('change'));
            document.getElementById('hidden-bank-code').value = selectedBank;
        });
        // 支店名の取得
        setupBasicSuggestSelect('#js-branch-name', '/client/findBranch', '支店名を入力', branchParamaterFilter, null, null);
		$('#js-branch-name').on('change', function(e) {
            let selectedBranch = $('#js-branch-name option:selected').val();
            if (isNaN(selectedBranch)) {
                selectedBranch = '';
            }
            document.getElementById('js-branch-code').textContent = selectedBranch;
        });

        document.getElementById('edit_biller').addEventListener('submit', function(e) {
            const bankCode = document.getElementById('js-bank-code').textContent;
            const branchCode = document.getElementById('js-branch-code').textContent;

            document.getElementById('hidden-bank-code').value = bankCode;
            document.getElementById('hidden-branch-code').value = branchCode;
        });
    }
});


// 支店名用パラメータフィルター
function branchParamaterFilter(params) {
    let selectedBank = $('#js-bank-name option:selected').val();
	var query = {
		search: params.term,
		code: selectedBank,
	}
	return query;
}
